import React from "react";
import { useState, useEffect } from "react";
import { getAllPipelines, getAllLinkedServices } from "../../serviceCalls";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { PageButton } from "../TableComponents/PageButton";
import {
  TableHead,
  TableCell,
  TableBody,
  Paper,
  Container,
  Button,
  styled,
} from "@mui/material";
import { Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import "../../images/namesort.png";
import { CustomTableCell } from "../TableComponents/TableCell";

import "../../images/PipelineIcon.png";
import "../../images/deleteButton.png";

import { useLocationContext } from "../../Hooks/CustomHooks";
import { useLocation, useNavigate } from "react-router-dom";
import { DeletePipelines } from "../DeletePipeline/deletePipeline";
import { CreatePipelines } from "../CreatePipeline/createPipeline";
import { appInsights } from "../../ApplicationInsightsService";
import {
  StyledCreatePipelineButton,
  StyledDeleteActionIconButton,
  StyledDeleteIcon,
  StyledEditActionButton,
  StyledPipelineHeading,
  StyledPipelineIcon,
  StyledTable,
  StyledTableContainer,
  StyledTableDataRow,
  StyledTableHeaderRow,
  style,
  successStyle,
  StyledError,
  StyledSortedIcon,
} from "./getAllPipelinesStyles";
import { ProgressBar } from "../CustomProgressBar/ProgressBar";

const GetAllPipelines = () => {
  const [data, setData] = useState([]);
  const location = useLocation();
  const [error, setError] = useState(null);
  const [numberInput, setNumberInput] = useState("");
  const [limit, setLimit] = useState(location.state ? location.state.limit : 5);
  const [pageNo, setPageNo] = useState(
    location.state ? location.state.pageNo : 1
  );
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { instance, accounts } = useMsal();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const currentLocation = useLocationContext();
  const [pipelineId, setPipelineId] = useState("");
  const [deletePipelineName, setDeletePipelineName] = useState("");
  const [correlationId, setCorrelationId] = useState("");
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [sortAscending, setSortAscending] = useState(true);
  const [startAt, setStartAt] = useState(1);
  const [endAt, setEndAt] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  const [noOfPages, setNoOfPages] = useState(0);
  const [linkedServices, setlinkedServices] = useState([]);

  const pipelineProperties = [
    "MappingId",
    "ReferenceKey",
    "Name",
    // "OriginTypeId",
    "OriginTypeName",
    // "DestinationTypeId",
    "DestinationTypeName",
    "OriginLinkedServiceName",
    "DestinationLinkedServiceName",
    "Scope",
    "FileType",
    "ColumnDelimiter",
  ];
  const headers = [
    "Pipeline ID",
    "Reference Key",
    "Pipeline Name",
    // "Origin Type Id",
    "Origin Type Name",
    // "Destination Type Id",
    "Destination Type Name",
    "Origin LinkedService Name",
    "Destination LinkedService Name",
    "Scope",
    "File Type",
    "Column Delimiter",
  ];
  useEffect(() => {
    setLoading(true);

    RequestPipelineData({ PageNo: parseInt(pageNo), Limit: parseInt(limit) });
  }, [limit, pageNo]);

  const handleDeletePipeline = (currentpipelineId, currentpipelineName) => {
    appInsights.trackEvent({
      name: `handleDeletePipeline method called for opening  delete Modal for deleting pipeline`,
    });
    setPipelineId(currentpipelineId);
    setDeletePipelineName(currentpipelineName);
    setOpenDeleteModal(true);
  };

  const handleCreatePipeline = async (event) => {
    appInsights.trackEvent({
      name: `handleCreatePipeline method called to Open create pipeline form `,
    });
    setOpenCreateModal(true);
  };

  const handleSort = () => {
    setLoading(true);
    if (sortAscending) {
      const sortedData = [...data].sort((a, b) => b.MappingId - a.MappingId);
      setData(sortedData);
      setSortAscending(false);
    } else if (!sortAscending) {
      const sortedData = [...data].sort((a, b) => a.MappingId - b.MappingId);
      setData(sortedData);
      setSortAscending(true);
    }

    setLoading(false);
  };

  async function RequestPipelineData(payload) {
    try {
      setLoading(true);
      appInsights.trackEvent({
        name: `RequestPipelineData method called for getting all pipeline data`,
      });
      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });
      const accessToken = await tokenResponse.accessToken;
      const response = await getAllPipelines(payload, accessToken);
      const apiresponse = await response?.data;
      const pipelineRecords = apiresponse.Pipelines.map(item => ({
        MappingId: item.MappingId,
        ReferenceKey: item.ReferenceKey,
        Name: item.Name,
        OriginTypeId: item.OriginTypeId,
        OriginTypeName: item.OriginTypeName,
        DestinationTypeId: item.DestinationTypeId,
        DestinationTypeName: item.DestinationTypeName,
        OriginLinkedServiceName: item.OriginLinkedServiceName,
        DestinationLinkedServiceName: item.DestinationLinkedServiceName,
        Scope: item.Scope,
        FileType: item.FileType,
        ColumnDelimiter: item.ColumnDelimiter
      }));

      const getLinkedServiceResponse = (await getAllLinkedServices(accessToken))
        .data;
      
      
      await setRowCount(apiresponse?.length);
      const totalRecords = apiresponse?.TotalCount
        ? apiresponse.TotalCount
        : totalCount;
      const noOfPages = Math.ceil(totalRecords / limit);
      const noOfRecordsCurrentPage = apiresponse?.Pipelines.length;
      const startAt = (pageNo - 1) * limit + 1;
      const endAt = startAt + noOfRecordsCurrentPage - 1;
      setStartAt(startAt);
      setEndAt(endAt);
      setTotalCount(totalRecords);
      setNoOfPages(noOfPages);
      setData(pipelineRecords);
      setlinkedServices(getLinkedServiceResponse);
    } catch (error) {
      setHasError(true);
      setErrorMessage(error.message);
      setCorrelationId(error.response.headers["x-correlation-id"]);
    }
    setLoading(false);
  }
  const navigate = useNavigate();
  const handleCloseButtonClick = (path) => {
    navigate(path);
  };
  const handleEditButtonClick = (pipelineData) => {
    appInsights.trackEvent({
      name: `handleEditButtonClick method called for navigating to edit-pipeline page`,
    });
    navigate("edit-pipeline", {
      state: {
        pipelineData: pipelineData,
        linkedService: linkedServices,
        pageNo: pageNo,
        limit: limit,
      },
    });
  };

  return (
    <>
      {hasError ? (
        <StyledError>
          Error Occurred: {errorMessage}. Correlation Id: {correlationId}
        </StyledError>
      ) : (
        <Container>
          <Box sx={{ display: "inline-flex" }}>
            <StyledPipelineHeading>
              List Screen - Pipelines
            </StyledPipelineHeading>
            <StyledPipelineIcon
              alt="PipelineIcon"
              src={require("../../images/PipelineIcon.png")}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", my: 2 }}>
            <StyledCreatePipelineButton
              variant="contained"
              onClick={handleCreatePipeline}
            >
              Create Pipeline
            </StyledCreatePipelineButton>
          </Box>
          {loading ? (
            <ProgressBar />
          ) : (
            <StyledTableContainer component={Paper}>
              <StyledTable stickyHeader aria-label="sticky table">
                <TableHead>
                  <StyledTableHeaderRow>
                    {headers.map((header) =>
                      header === "Pipeline ID" ? (
                        <CustomTableCell
                          id={header.key}
                          enableTootip={false}
                          fontColor={"#666461"}
                          value={header}
                        >
                          <StyledSortedIcon
                            onClick={() => handleSort()}
                            src={require("../../images/namesort.png")}
                          />
                        </CustomTableCell>
                      ) : (
                        <CustomTableCell
                          value={header}
                          id={header.key}
                          enableTootip={false}
                          fontColor={"#666461"}
                        />
                      )
                    )}
                    <CustomTableCell fontColor={"#666461"} value={"Actions"} />
                  </StyledTableHeaderRow>
                </TableHead>
                <TableBody>
                  {data?.map((item) => (
                    <StyledTableDataRow>
                      {pipelineProperties.map((key) =>
                        key === "MappingId" ? (
                          <CustomTableCell
                            value={item[key]}
                            enableTootip={true}
                            fontColor={"secondary"}
                          />
                        ) : (
                          <CustomTableCell
                            value={item[key]}
                            enableTootip={true}
                          />
                        )
                      )}
                      <TableCell>
                        <Box sx={{ display: "inline-flex" }}>
                          <StyledEditActionButton
                            variant="contained"
                            onClick={() => handleEditButtonClick(item)}
                          >
                            <span>Edit</span>
                            <EditIcon sx={{ color: "#FAFAFA" }} />
                          </StyledEditActionButton>
                          <StyledDeleteActionIconButton
                            variant="contained"
                            onClick={() =>
                              handleDeletePipeline(
                                item["MappingId"],
                                item["Name"]
                              )
                            }
                          >
                            <StyledDeleteIcon
                              src={require("../../images/deleteButton.png")}
                              alt="DeleteIcon"
                            ></StyledDeleteIcon>
                          </StyledDeleteActionIconButton>
                        </Box>
                      </TableCell>
                    </StyledTableDataRow>
                  ))}
                </TableBody>
              </StyledTable>
            </StyledTableContainer>
          )}
          <PageButton
            pageNo={pageNo}
            setPageNo={setPageNo}
            limit={limit}
            setLimit={setLimit}
            totalCount={totalCount}
            noOfPages={noOfPages}
            startAt={startAt}
            endAt={endAt}
          />
          <Box
            width="auto"
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              sx={{
                background: "var(--color-brand-Green-Medium, #7CBA25)",
                borderRadius: 1.5,
                fontSize: 15,
                "&:hover": {
                  background: "var(--color-brand-Green-Medium, #7CBA25)",
                },
              }}
              onClick={() => {
                handleCloseButtonClick("/");
              }}
            >
              Close
            </Button>
          </Box>
        </Container>
      )}
      <div>
        <CreatePipelines
          openCreateModal={openCreateModal}
          setOpenCreateModal={setOpenCreateModal}
          pageNo={pageNo}
          setPageNo={setPageNo}
          limit={limit}
          setLimit={setLimit}
          totalCount={totalCount}
          startAt={startAt}
          endAt={endAt}
          RequestPipelineData={RequestPipelineData}
          linkedServices={linkedServices}
        ></CreatePipelines>
      </div>
      <div>
        <DeletePipelines
          openDeleteModal={openDeleteModal}
          setOpenDeleteModal={setOpenDeleteModal}
          pipelineId={pipelineId}
          pipelineName={deletePipelineName}
          pageNo={pageNo}
          setPageNo={setPageNo}
          limit={limit}
          setLimit={setLimit}
          totalCount={totalCount}
          startAt={startAt}
          endAt={endAt}
          RequestPipelineData={RequestPipelineData}
        />
      </div>
    </>
  );
};

export default GetAllPipelines;
